<template>
    <div class="row px-3">
        <!-- Table Update -->
        <TableUpdate 
            @openUpload="openUpload"
            :showThen = "showThen"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @ShowMessage="ShowMessage"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import Cost from './costs.vue';
import CostTwo from './costTwos.vue';
import FormLote from '../../products/formLote.vue';
import ModalForm from '../../../../components/modal.vue'
import Recommendation from './recommendation.vue';
import MicroRecommendation from './microRecommendation.vue';
import Reposition from './sales/reposition.vue'
import FormPriceOther from './sales/formPriceOther.vue';
import FormPriceStore from './sales/formPriceStore.vue';
import Stock from './sales/stock.vue'
import TableUpdate from './tableUpdate.vue';
import Transaction from './sales/transaction.vue'
import MasterOffer from './masterOffer.vue';
import BatchUpdatePolicy from '../../productScraping/policies/batch.vue';
export default {
    data(){
        return{
            propHead: {
                action: "",
                open: false,
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: '',
            showThen:{
                show:false,
                resolve: true,
                message: '',
                title: '',
            }
        }
    },
    components:{
        Cost,
        CostTwo,
        FormLote,
        ModalForm,
        Recommendation,
        MicroRecommendation,
        Reposition,
        Stock,
        TableUpdate,
        Transaction,
        FormPriceOther,
        FormPriceStore,
        BatchUpdatePolicy,
        MasterOffer
    },
    methods:{
        closeModal() {
            this.propHead = {
                action: "",
                open: false,
                module: "clientes",
            };
            this.componentName = null
        },
        refrest() {
            this.closeModal();
        },
        openUpload({name,title,description}){
            this.componentName = name
            this.propHead = {
                open:true,
                action:title,
                text:description,
                component:this.componentName
            }
        },
        ShowMessage({show,resolve,message,title}){
            if(!resolve){
                message = 'Error al actualizar los datos.  Por favor, vuelve a intentarlo luego'
            }
            this.showThen = {
                show:show,
                resolve:resolve,
                message:message,
                title:title
            }
        }
    }
}
</script>